import Canvas from './Canvas';
import { useEffect, useState } from 'react';
import * as msc from "mascot-vis";
import EventLayer from './EventLayer';
import ToolBar from './ToolBar';
import Inspector from './Inspector';
import LayerView from './LayerView';
import DataPanel from './DataPanel';
import './css/App.css';
import store from "./store";
import { directSelect, select, toggleAxisHandle } from "./canvasSlice";
import InteractiveLegend from './InteractiveLegend';
import { useSearchParams } from 'react-router-dom';

function Authoring(props) {

  const [queryParameters] = useSearchParams();
  const [renderer] = useState(msc.renderer("svg", "canvas"));
  const [scene, setScene] = useState(msc.scene());
  // const [spec, setSpec] = useState("");
  const [datasets, setDatasets] = useState([]);
  const [undoStack, setUndoStack] = useState([]); 
  const [redoStack, setRedoStack] = useState([]); 

  useEffect(() => {
    document.body.style.backgroundColor = "#ddd";
    document.body.style.overflow = "hidden";
  }, [])

  useEffect(() => {
    let proj = queryParameters.get("project");
    if (proj) {
      fetch("/app/scenes/" + proj + ".msc")
      .then(response => {
        return response.text()
      })
      .then(result => {
        try {
          const scn = JSON.parse(result);
          loadScene(scn);
        } catch (err) {
          console.warn("Invalid project: " + proj);
        }
      });
    }
  }, [queryParameters])

  // useEffect(() => {
  //   if (spec) {
  //     fetch("app/scenes/" + spec + ".msc")
  //     .then(response => response.json())
  //     .then(result => {
  //       loadScene(result);
  //     });
  //   }
  // }, [spec]);

  useEffect(() => {
    store.dispatch(toggleAxisHandle({visible: false}));
    store.dispatch(select([]));
    store.dispatch(directSelect(null));
    renderer.clear();
    renderer.render(scene);
  }, [renderer, scene]);

  const loadScene = (json) => {
    let loader = msc.sceneLoader();
    let scn = loader.load(json);
    setScene(scn);
    setDatasets(Object.values(loader.tables));
    //setDatasets(Object.values(scn.getDataTables()));
  }

  // const demos = [
  //   "Rect",
  //   "BarChartHorz",
  //   "BarChartVert",
  //   "BoxPlot",
  //   "BulletChart",
  //   "DivergingBarChart",
  //   "GanttChart",
  //   "GroupedBarChart",
  //   "HeatMap",
  //   "Histogram",
  //   "MosaicPlot",
  //   "StackedBarChart",
  //   "TowerChart",
  //   "Treemap",
  //   "WaffleChart",
  //   "WaterfallChart",
  //   "BubblePlot",
  //   "CirclePacking",
  //   "DotPlot",
  //   "DoughnutChart",
  //   "PieChart",
  //   "RadialBarChart",
  //   "Scatterplot",
  //   "Sunburst",
  //   "BumpChart",
  //   "ConnectedScatterPlot",
  //   "DumbbellChart",
  //   "LineGraph",
  //   "LineGraph2",
  //   "LollipopChart",
  //   "MultiLineGraph",
  //   "ParallelCoordinates",
  //   "RangeChart",
  //   "SlopeGraph",
  //   "StringlineChart",
  //   "AreaChart",
  //   "DensityPlot",
  //   "RadarChart",
  //   "RidgelinePlot",
  //   "RoseChart",
  //   "StackedAreaChart",
  //   "StellarChart",
  //   "StreamGraph",
  //   "ViolinPlot",
  //   "Isotype",
  //   "GridAreaChart",
  //   "MultipleBarCharts",
  //   "MultipleBoxPlots",
  //   "MultiplePieCharts",
  //   "ScatterplotMatrix",
  //   "Sparklines",
  //   "GridStackedAreaChart",
  //   "MultipleViolinPlots"
  // ]

  // const loadDataset = (d) => {
  //   setDatasets(datasets.concat([d]));
  // }

  const resetStacks = () => {
    setUndoStack([]);
    setRedoStack([]);
  }

  return (
    <div style={{overflow: "hidden"}}>
      <Canvas scene={scene} renderer={renderer} datasets={datasets} undoStack={undoStack} redoStack={redoStack} type="svg"></Canvas>
      <EventLayer scene={scene} renderer={renderer} datasets={datasets} undoStack={undoStack} redoStack={redoStack}></EventLayer>
      {/* <div id="specList" style={{display: 'none'}}>
        <ul>
          {demos.map(d => <li key={d} onClick={(e) => setSpec(d)}>{d}</li>)}
        </ul>
      </div> */}
      {/* <div id="zoomCtrl">
        <button key="zoom+" className="zoomBtn" id="zoomInBtn"></button>
        <input type="range" min="25" max="400" orient="vertical" defaultValue="100" step="25" className="zoomSlider" id="zoomSlider" onChange={(e) => console.log(e)}></input>
        <button key="zoom-" className="zoomBtn" id="zoomOutBtn"></button>
      </div> */}
      <DataPanel scene={scene} renderer={renderer} datasets={datasets} undoStack={undoStack} loadDataset={setDatasets}></DataPanel>
      <LayerView scene={scene} renderer={renderer}></LayerView>
      <ToolBar scene={scene} renderer={renderer} datasets={datasets} undoStack={undoStack} redoStack={redoStack} resetStacks={resetStacks} loadScene={loadScene}></ToolBar>
      <Inspector scene={scene} renderer={renderer} datasets={datasets} undoStack={undoStack}></Inspector>
      <InteractiveLegend scene={scene} renderer={renderer}></InteractiveLegend>
      <input type="text" id="textElement" style={{"visibility": 'hidden', "position": "absolute"}}></input>
    </div>
  )
}

export default Authoring;
